import React, {useState} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { useConditionalHelper } from '../Conditional';
import { selectableDateRanges } from '../../../Data/DateRanges';
import { dateToString } from '../../../Services/helpers';

const DateRange = ({label = 'Date range', name = 'dateRange', help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? 'allTime';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [isCustom, setIsCustom] = useState(value.includes(':'));

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const selectChange = (e) => {
        let newVal = e.target.value;
        if (newVal === 'custom') {
            setIsCustom(true);
            const date = new Date();
            newVal = dateToString(new Date(date.setMonth(date.getMonth() - 1))) + ':' + dateToString(new Date());
        } else {
            setIsCustom(false);
        }

        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const changeCustom = (from, to) => {
        const newVal = from + ':' + to;
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <select
            id={name}
            name={name}
            className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent surface-1 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100 focus:ring-0"
            defaultValue={value}
            onChange={selectChange}
            disabled={isDisabled}
        >
            {selectableDateRanges.map((option, index) => {
                if (typeof option === 'string') {
                    return <option key={index} value={option}>{option}</option>
                } else {
                    return <option key={index} value={option.value}>{option.label}</option>
                }
            })}
            <option value={isCustom ? value : 'custom'}>Custom</option>
        </select>

        {isCustom && <Custom {...{value, changeCustom, isDisabled}} />}

    </CommonFieldWrapper>
}

const Custom = ({value, changeCustom, isDisabled}) => {
    const [from, to] = value.split(':');

    return <div className="mt-2 relative flex flex-row justify-around gap-4">
        <input className="block w-1/2 md:w-1/3 border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6 placeholder-fix"
            type="date"
            value={from}
            onChange={e => changeCustom(e.target.value, to)}
            disabled={isDisabled}
            placeholder="dd/mm/yyyy"
        />
        <input className="block w-1/2 md:w-1/3 border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6 placeholder-fix"
            type="date"
            value={to}
            onChange={e => changeCustom(from, e.target.value)}
            disabled={isDisabled}
            placeholder="dd/mm/yyyy"
        />
    </div>
}

export default DateRange;
